<script>
import { Radar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'EnergyChartRadar',
  extends: Radar,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = data.rawValue[tooltipItem.datasetIndex][tooltipItem.index];
                    let unit = 'mwh';
                    if (label) {
                        label += ': ';
                    }
                    if (value > 1000000000000000) {
                        unit = 'TWh';
                        value = Math.round(value / 1000000000000000 * 10) / 10
                    } else if (value > 1000000000000) {
                        unit = 'GWh';
                        value = Math.round(value / 1000000000000 * 10) / 10
                    } else if (value > 1000000000) {
                        unit = 'MWh';
                        value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value > 1000000) {
                        unit = 'kWh';
                        value = Math.round(value / 1000000 * 10) / 10
                    } else if (value > 1000) {
                        unit = 'Wh';
                        value = Math.round(value / 1000 * 10) / 10
                    } else {
                        value = Math.round(value * 10) / 10
                    }

                    label += value + ' ' + unit;
                    return label;
                },
                title: function(tooltipItem)
                {
                  return "";
                }
            }
        },
        scale: {
                ticks: {
                  beginAtZero: true,
                  display: false,
                  max:1,
                },
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>